import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { STabs, STabList, STab, STabPanel } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import { useQuery } from "react-query";
import { useSearchContext } from "../../context/search";
import { getSearchResult } from "../../api/search/search";
import { useState, useEffect } from "react";
import { QueryLoader } from "../../components/Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { FilteredDecisionSlider } from "../../components/DecisionList/FilteredDecisionSlider";
import { getDecisionsListByCategory, getDecisionsListByLabel } from "../../api/decision/decision";
import { SearchFilters } from "../../components/SearchFilters";
import { DecisionList } from "../../components/DecisionList/DecisionList";

export default function SearchPage() {
	const {
		state: { filters, phrase },
		dispatch,
	} = useSearchContext();

	const { axiosPrivate } = useAxiosPrivate();

	const [currentSearchPhrase, setCurrentSearchPhrase] = useState(phrase);
	const [resultIds, setResultIds] = useState(false);
	const [categoriesList, setCategoriesList] = useState(false);
	const [labelsList, setLabelsList] = useState(false);
	const { isLoading, isError, error, data, refetch } = useQuery(["decisionsList", currentSearchPhrase, filters], () =>
		getSearchResult(axiosPrivate, currentSearchPhrase, false, filters)
	);

	useEffect(() => {
		if (phrase !== "" || localStorage.getItem("search")) {
			setCurrentSearchPhrase(phrase ? phrase : localStorage.getItem("search"));
			refetch();
			dispatch({ type: "SET_PHRASE", payload: { phrase: "" } });
		}
	}, [phrase]);

	useEffect(() => {
		if (!isLoading && !isError) {
			const res = Array.isArray(data) ? [...data] : [];
			setResultIds([...res.map((e) => e.id)]);

			const catList = {
				ongoing: {},
				done: {},
				archive: {},
			};
			const labList = {
				ongoing: {},
				done: {},
				archive: {},
			};

			const ongoing = Array.isArray(data) ? data.filter((e) => e.status.slug === "ongoing") : [];
			const done = Array.isArray(data) ? data.filter((e) => e.status.slug === "done") : [];
			const archive = Array.isArray(data) ? data.filter((e) => e.status.slug === "archive") : [];

			ongoing.map((e) => {
				catList.ongoing[e.category.id] = e.category.name;
				labList.ongoing[e.label.id] = e.label.name;
			});
			done.map((e) => {
				catList.done[e.category.id] = e.category.name;
				labList.done[e.label.id] = e.label.name;
			});
			archive.map((e) => {
				catList.archive[e.category.id] = e.category.name;
				labList.archive[e.label.id] = e.label.name;
			});

			setCategoriesList(catList);
			setLabelsList(labList);
		}
	}, [data, isLoading]);

	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
					<SearchFilters />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<h1>Search result</h1>
					</StyledPageHeader>
					
					<span>{!isLoading && !isError ? data.length : "0"} search results</span>

					{isLoading ? (
						<QueryLoader />
					) : isError ? (
						<p>{`An error occured, please reload the page - ${error}`}</p>
					) : (
						<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
							<STabList>
								<STab>Ongoing</STab>
								<STab>Done</STab>
								<STab>Archive</STab>
							</STabList>
							<STabPanel>
								<DecisionList clearSearchResults={false} data={Array.isArray(data) ? data.filter((e) => e.status.slug === "ongoing") : []} />
								{Array.isArray(data) && data.filter((e) => e.status.slug === "ongoing").length > 0 && (
									<>
										{categoriesList && labelsList && (
											<>
												<FilteredDecisionSlider
													name={"Label"}
													requestFunc={(axiosPrivate) => {
														const labelIds = [];
														Object.keys(labelsList?.ongoing).map((e) => labelIds.push(e));

														return getDecisionsListByLabel(axiosPrivate, labelIds, 1, resultIds, 5);
													}}
													options={labelsList?.ongoing}
												/>
												<FilteredDecisionSlider
													name={"Category"}
													requestFunc={(axiosPrivate) => {
														const categoriesIds = [];
														Object.keys(categoriesList?.ongoing).map((e) => categoriesIds.push(e));

														return getDecisionsListByCategory(axiosPrivate, categoriesIds, 1, resultIds, 5);
													}}
													options={categoriesList?.ongoing}
												/>
											</>
										)}
									</>
								)}
							</STabPanel>
							<STabPanel>
								<DecisionList clearSearchResults={false} data={Array.isArray(data) ? data.filter((e) => e.status.slug === "done"): []} />
								{Array.isArray(data) && data.filter((e) => e.status.slug === "done").length > 0 && (
									<>
										{categoriesList && labelsList && (
											<>
												<FilteredDecisionSlider
													name={"Label"}
													requestFunc={(axiosPrivate) => {
														const labelIds = [];
														Object.keys(labelsList?.done).map((e) => labelIds.push(e));

														return getDecisionsListByLabel(axiosPrivate, labelIds, 1, resultIds, 5);
													}}
													options={labelsList?.done}
												/>
												<FilteredDecisionSlider
													name={"Category"}
													requestFunc={(axiosPrivate) => {
														const categoriesIds = [];
														Object.keys(categoriesList?.done).map((e) => categoriesIds.push(e));

														return getDecisionsListByCategory(axiosPrivate, categoriesIds, 1, resultIds, 5);
													}}
													options={categoriesList?.done}
												/>
											</>
										)}
									</>
								)}
							</STabPanel>
							<STabPanel>
								<DecisionList clearSearchResults={false} data={Array.isArray(data) ? data.filter((e) => e.status.slug === "archive") : []} />
								{Array.isArray(data) && data.filter((e) => e.status.slug === "archive").length > 0 && (
									<>
										{categoriesList && labelsList && (
											<>
												<FilteredDecisionSlider
													name={"Label"}
													requestFunc={(axiosPrivate) => {
														const labelIds = [];
														Object.keys(labelsList?.archive).map((e) => labelIds.push(e));

														return getDecisionsListByLabel(axiosPrivate, labelIds, 1, resultIds, 5);
													}}
													options={labelsList?.archive}
												/>
												<FilteredDecisionSlider
													name={"Category"}
													requestFunc={(axiosPrivate) => {
														const categoriesIds = [];
														Object.keys(categoriesList?.archive).map((e) => categoriesIds.push(e));

														return getDecisionsListByCategory(axiosPrivate, categoriesIds, 1, resultIds, 5);
													}}
													options={categoriesList?.archive}
												/>
											</>
										)}
									</>
								)}
							</STabPanel>
						</STabs>
					)}
				</Col>
			</Row>
		</Container>
	);
}
